module.exports = __webpack_public_path__ + "static/media/C012.899a01c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C012.jpg
// module id = 295
// module chunks = 0